
import { GoogleGenAI } from "@google/genai";

export const getConstructionAdvice = async (query: string) => {
  const ai = new GoogleGenAI({ apiKey: process.env.GEMINI_API_KEY });
  const model = 'gemini-3-flash-preview';

  try {
    const response = await ai.models.generateContent({
      model,
      contents: `You are the Chief Civil Engineer and Advisor for Sai SSK Infrastructures. 
      Clients might ask about complex topics like:
      - Bituminous vs Cement Concrete (CC) road lifespans.
      - Soil stabilization techniques (using fly ash, lime, or geogrids).
      - Highway maintenance cycles (milling, resurfacing).
      - Project cost Estimation factors (Labor, RMC, Bitumen price fluctuations).
      
      Job seekers might ask about safety standards (OHSAS) and engineering career paths.
      
      Instructions: 
      1. Provide high-quality, technically sound advice as a road construction authority.
      2. If asked about costs, explain the variables involved in major infrastructure projects.
      3. Maintain an industrial, reliable, and expert tone.
      
      User Query: ${query}`,
      config: {
        systemInstruction: "You represent Sai SSK Infrastructures. Your goal is to showcase technical expertise in heavy civil engineering and road construction. Be concise, authoritative, and helpful.",
        temperature: 0.5,
      }
    });

    return response.text;
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "Our technical systems are currently processing high-volume field data. For urgent engineering consultations, please contact hq@sai-ssk.com.";
  }
};
